import { PAYMENT_METHODS, SERVICES } from '@autopass-web/domain';

import Client from '../client';

import type { ConfirmPaymentInfo, PaymentInfo, Receipt } from './types';

interface CreateEasyWalletSessionProps {
  paymentInfo: PaymentInfo;
  receipt: Receipt;
  email: string | undefined;
}

export const createEasyWalletSession = async ({
  paymentInfo,
  receipt,
  email,
}: CreateEasyWalletSessionProps) => {
  const callbackUrlParams = new URLSearchParams({
    paymentType: PAYMENT_METHODS.EASY_WALLET,
    serviceType: SERVICES.APS,
    parkingTicketId: paymentInfo.id,
    plateNumber: paymentInfo.plateNumber,
  });

  const callbackUrl = `${
    window.location.origin
  }/auth?${callbackUrlParams.toString()}`;

  const { data } = await Client.createWalletSession({
    callbackUrl,
    parkingTicketId: paymentInfo.id,
    email,
    receipt,
    walletType: 'easy_wallet',
  });

  return data.data.redirect_link;
};

interface ConfirmEasyWalletTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmEasyWalletTransaction = async ({
  confirmPaymentInfo,
}: ConfirmEasyWalletTransactionProps) => {
  const { data } = await Client.authApsWalletPay({
    transactionId: confirmPaymentInfo.merchantTransactionId,
    walletType: 'easy_wallet',
  });

  return data;
};
